import {elements, providers} from './vue-data-table-form-providers'

export default class VueDataTableFormProvider {

    _elements;
    _listeners;

    constructor(provider = providers.FORM) {
        this.provider = provider;
        this._listeners = [];
    }

    set provider(provider) {
        this._elements = elements[provider || providers.FORM] || elements[providers.FORM];
    }

    get elements() {
        return this._elements;
    }

    getElement(formType) {
        return this._elements[formType];
    }

}
